import { useEffect, useState } from "react";
import { schemaWithEmailValidator } from "../models/schemasV2";
import { fetchFastApi } from "../api/fastapi";
import { toast } from "sonner";
import { z } from "zod";

interface UseTemplatesV2Props {
  fetchOnLoad?: boolean;
}

export const useTemplatesV2 = ({ fetchOnLoad = true }: UseTemplatesV2Props) => {
  const [loading, setLoading] = useState(fetchOnLoad);
  const [schemas, setSchemas] = useState<
    z.infer<typeof schemaWithEmailValidator>[]
  >([]);

  const fetchSchemas = async () => {
    setLoading(true);
    try {
      const data = await fetchFastApi({ path: "/schemas/v2/", method: "GET" });
      if (data.schemas) {
        setSchemas(data.schemas);
      }
    } catch (error) {
      toast.error("An error occurred while fetching templates");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (fetchOnLoad) {
      fetchSchemas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { loading, schemas, fetchSchemas };
};
